import { type AxiosInstance } from "axios";
import { SANSAN_CONNECTION_ENDPOINT } from "@/features/sansanIntegration/api/getConnection";
import { type SansanConnectionResponse } from "@/features/sansanIntegration/types";

/**
 * Sansan APIキーを登録し、連携を開始する（`POST /sansan/connection/`）。
 * 保存前にバックエンドがSansanでキーを検証し、無効な場合は400になる。すでに連携中の場合は409になる。
 * 差し替えのAPIはないため、APIキーを替える場合は連携を解除してから登録し直す。
 */
export const postConnection = async (
  apiClient: AxiosInstance,
  apiKey: string
): Promise<SansanConnectionResponse> => {
  const { data } = await apiClient.post<SansanConnectionResponse>(
    SANSAN_CONNECTION_ENDPOINT,
    { apiKey }
  );
  return data;
};
